/**
 * Art. 155 §1 KP — years credited to the staż urlopowy for COMPLETING a
 * school. Verified against the statute (sip.lex.pl / przepisy.gofin.pl,
 * 2026): the credits are NOT summed — only the single most favourable one
 * counts; for education pursued WHILE employed, the more favourable of the
 * school credit or the overlapping employment period is taken (art. 155 §2).
 */
export const EDUCATION_CREDITS = [
  { key: 'none', years: 0 },
  { key: 'zawodowa', years: 3 },      // zasadnicza/branżowa szkoła zawodowa (max programowo)
  { key: 'liceum', years: 4 },        // średnia ogólnokształcąca
  { key: 'technikum', years: 5 },     // średnia zawodowa (także po ZSZ)
  { key: 'policealna', years: 6 },    // szkoła policealna
  { key: 'wyzsza', years: 8 },        // szkoła wyższa (licencjat/inżynier/magister — ten sam kredyt)
] as const;
export type EducationKey = (typeof EDUCATION_CREDITS)[number]['key'];

/** Suggested staż = documented non-overlapping employment years + the single education credit. */
export function suggestedSeniority(educationKey: EducationKey, employmentYears: number): number {
  const credit = EDUCATION_CREDITS.find((e) => e.key === educationKey)?.years ?? 0;
  const employment = Number.isFinite(employmentYears) && employmentYears > 0 ? employmentYears : 0;
  return Math.floor(employment) + credit;
}
